<av-content-container class="w-100" [fullHeight]="true">
  <div
    class="av-monitoring position-relative d-flex flex-column w-100 py-3 px-3 px-md-4"
    [attr.aria-busy]="facade.loading()"
  >
    <av-rail class="position-absolute top-0 start-0 w-100" [active]="refreshWait.visible()" />

    <header class="d-flex flex-column gap-1">
      <h1 class="av-monitoring__title h4 m-0">
        {{ 'app.reports.monitoring.title' | translate }}
      </h1>
      <p class="av-metric-hint m-0">{{ 'app.reports.monitoring.description' | translate }}</p>
    </header>

    <ng-template #toolbar>
      <app-monitoring-toolbar
        [from]="facade.from()"
        [to]="facade.to()"
        [exporting]="facade.exporting()"
        (rangeChange)="onRangeChange($event)"
        (exportRequested)="facade.exportWorkbook()"
      />
    </ng-template>

    @if (showSkeleton()) {
      <div class="d-flex flex-column gap-4" aria-busy="true">
        <span class="visually-hidden" aria-live="polite">
          @if (coldWait.visible()) {
            {{ 'app.reports.monitoring.loading' | translate }}
          }
        </span>
        @if (coldWait.visible()) {
          <av-skeleton shape="metrics" [rows]="3" />
          <av-skeleton shape="sections" [rows]="2" />
        }
      </div>
    } @else if (facade.hasError()) {
      <ng-container [ngTemplateOutlet]="toolbar" />
      <mat-card appearance="outlined" class="av-monitoring__error p-4 text-center">
        <mat-icon class="av-monitoring__error-icon mb-2">error</mat-icon>
        <p class="m-0 mb-3">{{ 'shared.api.errors.default' | translate }}</p>
        <button mat-flat-button color="primary" type="button" (click)="facade.reload()">
          <mat-icon>refresh</mat-icon>
          {{ 'shared.general.tooltips.refresh' | translate }}
        </button>
      </mat-card>
    } @else {
      <div class="av-monitoring__board">
        <app-monitoring-catalog-card
          class="av-monitoring__catalog"
          [catalog]="facade.catalog()"
          [progress]="countUp()"
        />
        <app-monitoring-duration-card
          class="av-monitoring__duration"
          [lifetime]="facade.lifetime()"
          [progress]="countUp()"
          [previousFrom]="facade.periods().previous.start"
        />
        <app-monitoring-volume-card
          class="av-monitoring__volume"
          [demands]="facade.demands()"
          [progress]="countUp()"
          [previousFrom]="facade.periods().previous.start"
        />
        <app-monitoring-approval-card
          class="av-monitoring__approval"
          [approval]="facade.approval()"
          [progress]="countUp()"
          [previousFrom]="facade.periods().previous.start"
        />

        <div class="av-monitoring__toolbar">
          <ng-container [ngTemplateOutlet]="toolbar" />
        </div>

        <app-monitoring-kind-comparison class="av-monitoring__kind" [byKind]="facade.byKind()" />
        <app-monitoring-status-breakdown
          class="av-monitoring__status"
          [byStatus]="facade.byStatus()"
        />
      </div>

      <div class="av-monitoring__tops">
        <app-monitoring-top-table
          titleKey="app.reports.monitoring.top.applications.title"
          hintKey="app.reports.monitoring.top.demandsHint"
          nameColumnKey="app.reports.monitoring.top.applications.column"
          countColumnKey="app.reports.monitoring.top.demandsColumn"
          emptyKey="app.reports.monitoring.top.applications.empty"
          [rows]="facade.top().applications"
          [rowLink]="applicationRowLink()"
          [progress]="countUp()"
        />
        <app-monitoring-top-table
          titleKey="app.reports.monitoring.top.groups.title"
          hintKey="app.reports.monitoring.top.demandsHint"
          nameColumnKey="app.reports.monitoring.top.groups.column"
          countColumnKey="app.reports.monitoring.top.demandsColumn"
          emptyKey="app.reports.monitoring.top.groups.empty"
          [rows]="facade.top().groups"
          [rowLink]="groupRowLink()"
          [progress]="countUp()"
        />
        <app-monitoring-top-table
          titleKey="app.reports.monitoring.top.validators.title"
          hintKey="app.reports.monitoring.top.validators.hint"
          nameColumnKey="app.reports.monitoring.top.validators.column"
          countColumnKey="app.reports.monitoring.top.validators.decisionsColumn"
          emptyKey="app.reports.monitoring.top.validators.empty"
          linkLabelKey="app.reports.monitoring.top.validators.viewDemands"
          [rows]="facade.top().validators"
          [rowLink]="validatorRowLink()"
          [progress]="countUp()"
        />
      </div>
    }
  </div>
</av-content-container>
